import { Component, inject, OnInit, signal, Signal } from '@angular/core';
import { Route } from '../../utils/route';
import { TabsComponent } from '../../components/tabs/tabs.component';
import { AuthenticationService } from '../../services/authentication.service';
import { MyLeavesComponent } from './my-leaves/my-leaves.component';
import { OverviewComponent } from './overview/overview.component';
import { PendingLeavesComponent } from './pending-leaves/pending-leaves.component';
import { GrantLeavesComponent } from './grant-leaves/grant-leaves.component';
import { UsersCategoriesComponent } from './users-categories/users-categories.component';
import { UserRole } from '../../interfaces/user-role';
import { isManagementRole, isRole } from '../../utils/user-roles';

import { LeaveBalanceComponent } from './leave-balance/leave-balance.component';

@Component({
  selector: 'app-leave-management',
  imports: [
    TabsComponent,
    MyLeavesComponent,
    OverviewComponent,
    PendingLeavesComponent,
    GrantLeavesComponent,
    UsersCategoriesComponent,
    LeaveBalanceComponent,
  ],
  templateUrl: './leave-management.component.html',
  styleUrl: './leave-management.component.scss',
})
export class LeaveManagementComponent extends Route implements OnInit {
  private authService = inject(AuthenticationService);
  permittedTabs = signal(['my-Leaves']);

  ngOnInit(): void {
    const userRole = this.authService.currentUserPolicy?.role;

    const permittedTabsArray = ['my-Leaves'];
    if (isManagementRole(userRole)) {
      permittedTabsArray.push('overview');
      permittedTabsArray.push('pending-Leaves');
    }

    if (isRole(userRole, UserRole.HR)) {
      permittedTabsArray.push('grant-leaves');
      permittedTabsArray.push('categories');
    }

    this.permittedTabs.set(permittedTabsArray);
  }
}
